import { DSRCalculationMethodService } from "@/modules/global-settings/loan-origination/services/other-settings/dsr-calculation-methods.service"
import Logger from '@/lib/logger';
import { make } from "vuex-pathify"
const service = new DSRCalculationMethodService()
export const state = {
  dsrCalculationMethods: [],
}
export const mutations = {
  ...make.mutations(state)
}
export const actions = {
 async fetchDSRCalculationMethods ({ commit }) {
    try {
      const { data } = await service.fetchDSRCalculationMethods();
      commit('SET_DSR_CALCULATION_METHODS', data);
      return data;
    } catch (error) {
      Logger.error('getting dsr calculation methods setting', error);
      throw error;
    }
  },
  async updateDSRCalculationMethod ({ dispatch }, payload) {
    try {
      await service.updateDSRCalculationMethod(payload);
      dispatch('fetchDSRCalculationMethods');
    } catch (error) {
      Logger.error('updating dsr calculation methods settings', error);
      throw error;
    }
  }
}
